import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CloseIcon from '@material-ui/icons/Close';
import { observer } from 'mobx-react';

import { buildAnchorLink, createHeaders } from '../../utils/helpers';
import callApi from '../../utils/callApi';
import { ANCHOR_BROADCAST_STATUS, ANCHOR_VIEW } from '../../constants/apiUrls/apiUrls';
import { RootStoreContext } from '../../context';

const REFRESH_INTERVAL = 10000;

@observer
class CurrentLiveAnchors extends Component {
  static contextType = RootStoreContext;

  constructor(props) {
    super(props);

    this.state = {
      liveAnchors: [],
      liveAnchorsCount: 0,
      isOpen: false,
      isLoaded: false,
      notification: null,
      left: -270,
    };

    this.getAnchorData = this.getAnchorData.bind(this);
    this.checkIfLive = this.checkIfLive.bind(this);
    this.toggleLiveAnchorsSection = this.toggleLiveAnchorsSection.bind(this);
  }

  componentDidMount() {
    const { uiStore: { notificationsDerivation } } = this.context;
    const { data } = notificationsDerivation;
    this.setState({ notification: data?.[data?.length - 1] });
    this.checkIfLive();
  }

  componentDidUpdate(prevProps, prevState) {
    const { uiStore: { notificationsDerivation } } = this.context;
    const { data } = notificationsDerivation;

    if (this.state.notification !== data?.[data?.length - 1]) {
      this.setState({ notification: data?.[data?.length - 1] });
      this.checkIfLive();
    }
  }

  getAnchorData(anchorId) {
    const URL = ANCHOR_VIEW.replace('{id}', anchorId);
    const { liveAnchors } = this.state;
    if (liveAnchors.find((anchor) => anchor.id === anchorId)) {
      return;
    }

    return callApi(URL, 'get');
  }

  async checkIfLive() {
    try {
      const res = await callApi(ANCHOR_BROADCAST_STATUS, 'get', null, null, createHeaders(), null, null, false);
      this.setState({ liveAnchors: [] });
      if (res.data.length) {
        const anchorsData = [];
        const limit = Math.min(2, res.data.length);
        for (let i = 0; i < limit; i++) {
          const data = await this.getAnchorData(res.data[i].id);
          anchorsData.push(data.data);
        }
        this.setState({
          liveAnchorsCount: anchorsData.length,
          liveAnchors: anchorsData,
          left: -270 - (30 * (anchorsData.length - 1))
        });
      } else {
        this.setState({ liveAnchorsCount: 0 });
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggleLiveAnchorsSection() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, isLoaded: true });
  }

  render() {
    const { liveAnchors, liveAnchorsCount, isOpen, isLoaded } = this.state;

    const buttonText = isOpen ? <CloseIcon /> : <ArrowForwardIosIcon />;

    return (
      <div
        className={classnames(
          'current-live-anchors', {
          'live-anchors-open': isOpen,
          'live-anchors-close': !isOpen && isLoaded,
          'hide-live-anchors': (liveAnchorsCount < 1),
        })}
        style={{ left: this.state.left }}
      >
        <small className="live-text">Currently Live!</small>
        {liveAnchors.map((anchor) => (
          <div key={anchor.id} className="current-live-anchor-container">
            <a className="current-live-anchor" href={buildAnchorLink(anchor)}>
              <img alt={anchor.nickname} className="" src={anchor?.notificationIcon} />
            </a>
          </div>
        ))}
        <div className="live-anchors-toggle-container">
          <button className="live-dismiss-btn" onClick={this.toggleLiveAnchorsSection}>
            {buttonText}
          </button>
          <small className="live-anchors-count">{liveAnchorsCount}</small>
        </div>
      </div>
    );
  }
}

export default CurrentLiveAnchors;
